import moment from 'moment';

import { PAGINATION_DEFAULT_VALUE } from '../defaultValue';

export const buildQueryParams = (query) => {
    const result = {
    };
    const integrationId = query.get('integrationId');
    if (integrationId) {
        if (integrationId.toLowerCase() === 'commerceship') {
            result.cs = true;
        } else {
            result.cs = false;
            result.integrationId = integrationId;
        }
    }
    result.page = (query.get('page') || PAGINATION_DEFAULT_VALUE.currentPage).toString();
    result.page_size = (query.get('page_size') || PAGINATION_DEFAULT_VALUE.pageSize).toString();
    if (query.has('sort_by')) {
        result.sort_by = query.get('sort_by');
    }
    if (query.has('shipStartDate')) {
        result.shipStartDate = moment(query.get('shipStartDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('shipEndDate')) {
        result.shipEndDate = moment(query.get('shipEndDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('domestic')) {
        if (query.get('domestic') !== 'all') {
            result.domestic = query.get('domestic') === 'domestic';
        }
    }
    if (query.has('ground')) {
        if (query.get('ground') !== 'all') {
            result.ground = query.get('ground') === 'ground';
        }
    }
    if (query.has('service_levels')) {
        result.serviceLevelGroups = query.getAll('service_levels');
    }
    if (query.has('carriers')) {
        result.carriers = query.getAll('carriers');
    }
    if (query.has('timeframe')) {
        result.timeframe = query.get('timeframe');
    }
    if (query.has('trackingNumber')) {
        result.trackingNumbers = query.getAll('trackingNumber');
    }
    if (query.has('warehouse_id')) {
        result.warehouseIds = query.getAll('warehouse_id');
    }
    if (query.has('zones')) {
        result.zones = query.getAll('zones');
    }
    if (query.has('to_state')) {
        result.toStates = query.getAll('to_state');
    }
    if (query.has('format')) {
        result.format = query.get('format');
    }
    return result;
};
